export const FILTER_BY_CATEGORY = 'FILTER_BY_CATEGORY';
export const FILTER_BY_SORT = 'FILTER_BY_SORT';
export const FILTER_BY_SEARCH = 'FILTER_BY_SEARCH';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
